<template>
	<div>
		<dyDetails v-if="$isDy()"></dyDetails>
		<ksDetails v-else></ksDetails>
	</div>
</template>
<script>
import dyDetails from './dyDetails.vue';
import ksDetails from './ksDetails.vue';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	components: {
		dyDetails,
		ksDetails,
	},
	data() {
		return {
			platformId: 2,
			PLATFORM_DY: +PLATFORM_DY.value,
		};
	},
	created() {
		this.platformId = +this.$route.query.platform_id || 2;
	},
	methods: {},
};
</script>
<style lang='less' scoped>
</style>